import React from "react";
import { useTranslation } from "react-i18next";

import { useOrganization } from "hooks/useOrganization";

import { OrganizationEdition } from "pages/organization/organization.types";

import ContextMenuItem from "../../ContextMenu/ContextMenuItem";
import { AQA_PRIVATE_LINK } from "../AqaIds";

type Props = {
  onClick: () => void;
};

export const PrivateLinkItemWrapper = ({ onClick }: Props) => {
  const { t } = useTranslation();

  const { data: organization } = useOrganization();

  if (organization.edition !== OrganizationEdition.enterprise) return null;

  return (
    <ContextMenuItem
      text={t("help_bar.request_private_link_item")}
      testId={AQA_PRIVATE_LINK}
      onClick={onClick}
    />
  );
};
